import React from 'react';
import { NavLink } from 'react-router-dom';

interface HighlightedLinkProps {
  to: string;
  text: string;
}

const HighlightedLink = ({ to, text }: HighlightedLinkProps) => {
  return (
    <NavLink
      exact
      to={to}
      className='font-raleway mx-6 px-6 py-3'
      activeClassName='font-extrabold text-white bg-timberwolf rounded-3xl'
    >
      {text}
    </NavLink>
  );
};

export default HighlightedLink;
